import BookManage from './BookManage.js';

export default BookManage;